import type { TileId } from '../../content/tiles';

/*
 * Mini-map colors (no Phaser here: the owner's review page draws lawns with them too).
 */

const THUMB_COLOR: Partial<Record<TileId, number>> = {
  hose: 0x3a8fe0, // the hose's blue tube (placeholderArt.ts paintHose)
  dogHouse: 0xc8553d,
  sprinkler: 0xff8a1f,
  judgesTable: 0xf4f1de,
  pen: 0xd9b860,
  penGate: 0xb08d5a,
  roboDock: 0x8a93a2,
  green: 0x7fcf68,
  flag: 0x7fcf68,
  ballWasher: 0x3a7bd5,
  grass: 0x3f9a35,
  tallGrass: 0x5aae46,
  meadowGrass: 0x58b046,
  beehive: 0xe2bf55,
  wheat: 0xb8902e,
  path: 0xc9b48a,
  sand: 0xd9c590,
  mud: 0x5a3a22,
  water: 0x5ec8ff,
  house: 0xb07a45, // the back deck
  barn: 0xb03a2e,
  flowerBed: 0xff6b8a,
  crops: 0x8a6a3a,
  headstone: 0x9aa0a6,
  lantern: 0xf2c94c,
  thorns: 0x5a3a4a,
  cobble: 0xb6b0a3,
  bridge: 0xa77a4a,
  urn: 0xc4bfb2,
  statue: 0xe4e0d8,
  fountain: 0x3a86c8,
  fieldLine: 0x8fd07a,
  goal: 0xf4f1de,
  cone: 0xff8a1f,
};
const THUMB_OBSTACLE = 0x163f19;
const THUMB_MOWED = [0x27702e, 0x1d5a25] as const;

/** A tile's color on a mini map (`mowed`: grass that has been cut, in stripes). */
export function thumbColor(tile: TileId, x: number, y: number, mowed: boolean): number {
  if (mowed) return THUMB_MOWED[x % 2]!;
  if (tile === 'grass' && (x + y) % 2 === 0) return 0x4aa83e;
  return THUMB_COLOR[tile] ?? THUMB_OBSTACLE;
}
